import {useParams} from 'react-router-dom'
import React from "react";
import AppBreadcrumbs from "../blocks/AppBreadcrumbs/AppBreadcrumbs";
import AppPrivacy from "../blocks/AppPrivacy/AppPrivacyBlock";
import {AppNavigation} from "../components/AppNavigation/AppNavigation";
import {AppFooter} from "../blocks/AppFooter/AppFooter";

export function AppPrivacyPage() {

    const {id} = useParams();

    return (
        <div>
            {id && <AppNavigation id={id}/>}
            {id && <AppBreadcrumbs id={id} title="Privacy Policy"/>}
            {id && <AppPrivacy id={id}/>}
            {id && <AppFooter id={id}/>}
        </div>
    )
}